import Phaser from 'phaser'
import FallingObject from '../ui/FallingObject.js'
import Laser from '../ui/Laser.js'
import ScoreLabel from '../ui/ScoreLabel.js'
import LifeLabel from '../ui/LifeLabel.js'
export default class HuntingAlienIo2 extends Phaser.Scene
{
	constructor()
	{
		super('hunting-alien-io-2')
	}

    init() {

        this.sparkles = undefined

        this.nav_right = false
        this.nav_left = false
        this.shoot = false
        this.cursor = undefined
        this.player = undefined

        this.speed = 200
        
        this.enemies = undefined
        this.enemySpeed = 60
        this.enemy = undefined

        this.lasers = undefined
        this.lastFired = 0

        this.button = undefined

        this.scoreLabel = undefined

        this.lifeLabel = undefined

        this.powerup = undefined

        this.backsound = undefined
    }

	preload()
    {
        this.load.image('level2', 'images/game2_bg.jpg')
        this.load.image('sparkle', 'images/sparkle.png')
        this.load.image('left-btn', 'images/left-btn.png')
        this.load.image('right-btn', 'images/right-btn.png')
        this.load.image('shoot-btn', 'images/shoot-btn.png')
        this.load.image('enemy2', 'images/enemy2.png')
        this.load.image('up-btn', 'images/up-btn.png')
        this.load.image('down-btn', 'images/down-btn.png')
        this.load.image('alien', 'images/Alien-Spaceship.png')
        
        
        this.load.spritesheet('player', 'images/ship.png', {frameWidth:124, frameHeight:66})

        this.load.spritesheet('laser1', 'images/laser-bolts.png', {
            frameWidth : 16, frameHeight: 16,
            startFrame: 32, endFrame: 16
        })

        this.load.image('powerup', 'images/powerup.png')

        this.load.audio('laserSound', 'sfx/sfx_laser.ogg')
        this.load.audio('destroySound', 'sfx/destroy.mp3')
        this.load.audio('powerupSound', 'sfx/handsanitizer.mp3')

        this.load.audio('backsound2', 'sfx/backsound/DeathMatch.ogg')
        this.load.audio('gameOverSound', 'sfx/gameover.wav')
        this.load.audio('winSound', 'sfx/win.wav')
        this.load.audio('startSound', 'sfx/backsound/BravePilots.ogg')
    }

    create()
    {
        const gameWidth = this.scale.width * 0.5
        const gameHeight = this.scale.height * 0.5
        this.add.image(gameWidth, gameHeight, 'level2').setScale(0.38).setScale(1)

        this.sparkles = this.physics.add.group({
            key: 'sparkle',
            repeat : 10
        })
        Phaser.Actions.RandomRectangle(this.sparkles.getChildren(), this.physics.world.bounds);

        this.createButton()

        this.player = this.createPlayer()

        this.cursor = this.input.keyboard.createCursorKeys()

        this.button = this.input.keyboard.addKeys({
            up : Phaser.Input.Keyboard.KeyCodes.W,
            down : Phaser.Input.Keyboard.KeyCodes.S,
            left : Phaser.Input.Keyboard.KeyCodes.A,
            right : Phaser.Input.Keyboard.KeyCodes.D,
            shoot : Phaser.Input.Keyboard.KeyCodes.SPACE 
        })

        this.enemies = this.physics.add.group({
            classType : FallingObject,

            maxSize : 10,
            runChildUpdate : true
        })

        this.time.addEvent({
            delay: 1500,
            callback: this.spawnEnemy,
            callbackScope: this,
            loop: true
        })

        this.lasers = this.physics.add.group({
            classType : Laser,
            maxSize : 10,
            runChildUpdate : true
        })

        this.physics.add.overlap(
            
            this.lasers, 
            this.enemies, 
            this.hitEnemy, 
            null, 
            this
        );

        this.scoreLabel = this.createScoreLabel(16, 16, 50)

        this.lifeLabel = this.createLifeLabel(16, 43, 3)

        this.physics.add.overlap(
            this.player,
            this.enemies,
            this.decreaseLife,
            null,
            this
            )

        this.powerup = this.physics.add.group({
            classType : FallingObject,
            runChildUpdate : true
        })

        this.time.addEvent({
            delay : 10000,
            callback : this.spawnPowerup,
            callbackScope: this,
            loop: true
        })

        this.physics.add.overlap(
            this.player,
            this.powerup,
            this.increaseLife,
            null,
            this
            )

            this.backsound = this.sound.add('backsound2')
            var soundConfig = {
                loop : true,
                volume : 0.05
            }
            this.backsound.play(soundConfig)
    }
    
    // @ts-ignore
    // @ts-ignore
    update(time) {
        this.sparkles.children.iterate((child) => {
            //arah gerak awan
            // @ts-ignore
            child.setVelocityY(70)

                // @ts-ignore
                if (child.y > this.scale.height){
                    // @ts-ignore
                    child.x = Phaser.Math.Between(0, 400)
                    // @ts-ignore
                    child.y = child.displayHeight / 10
                }
        })

        this.movePlayer(this.player, time)
    }

    createButton() {
        this.input.addPointer(3)
        let shoot = this.add.image(330, 540, 'shoot-btn').setScale(0.5).setInteractive().setDepth(0.5).setAlpha(0.8)

        let nav_left = this.add.image(50, 550, 'left-btn').setScale(0.5).setInteractive().setDepth(0.5).setAlpha(0.8)

        let nav_down = this.add.image(nav_left.x + nav_left.displayWidth + 7, 550, 'down-btn').setScale(0.5).setInteractive().setDepth(0.5).setAlpha(0.8)

        let nav_right = this.add.image(nav_down.x + nav_down.displayWidth, 550, 'right-btn').setScale(0.5).setInteractive().setDepth(0.5).setAlpha(0.8)

        let nav_up = this.add.image(nav_left.x + nav_left.displayWidth + 7, nav_down.y - nav_down.displayWidth - 15, 'up-btn').setScale(0.5).setInteractive().setDepth(0.5).setAlpha(0.8)

        nav_left.on('pointerdown', () => {this.nav_left = true}, this)
        nav_left.on('pointerout', () => {this.nav_left = false}, this)

        nav_right.on('pointerdown', () => {this.nav_right = true}, this)
        nav_right.on('pointerout', () => {this.nav_right = false}, this)

        nav_up.on('pointerdown', () => {this.nav_up = true}, this)
        nav_up.on('pointerout', () => {this.nav_up = false}, this)

        nav_down.on('pointerdown', () => {this.nav_down = true}, this)
        nav_down.on('pointerout', () => {this.nav_down = false}, this)

        shoot.on('pointerdown', () => {this.shoot = true}, this)
        shoot.on('pointerout', () => {this.shoot = false}, this)

        
    }

    // @ts-ignore
    // @ts-ignore
    movePlayer(player, time) {
        if((this.shoot) && time > this.lastFired) {
            const laser = this.lasers.get(0,0, 'laser1')
            if(laser) {
                laser.fire(this.player.x, this.player.y)
                this.lastFired = time + 150
            }
        }

        // @ts-ignore
        if (this.cursor.left.isDown || this.nav_left || this.button.left.isDown) {
            // @ts-ignore
            this.player.setVelocityX(this.speed * -1)
            // @ts-ignore
            this.player.anims.play('left', true)
            // @ts-ignore
            this.player.setFlipX(true)

        // @ts-ignore
        } else if (this.cursor.right.isDown || this.nav_right || this.button.right.isDown) {
            // @ts-ignore
            this.player.setVelocityX(this.speed)
            // @ts-ignore
            this.player.anims.play('right', true)
            // @ts-ignore
            this.player.setFlipX(false)

        // @ts-ignore
        } else if(this.cursor.up.isDown || this.nav_up || this.button.up.isDown){
            // @ts-ignore
            this.player.setVelocityY(this.speed * -1)
            // @ts-ignore
            this.player.anims.play('turn', true)
            
        
        // @ts-ignore
        } else if(this.cursor.down.isDown|| this.nav_down || this.button.down.isDown){
            // @ts-ignore
            this.player.setVelocityY(this.speed)
            // @ts-ignore
            this.player.anims.play('turn', true)

        }else {
            // @ts-ignore
            this.player.setVelocity(0)
            // @ts-ignore
            this.player.anims.play('turn')
        }

        
        // @ts-ignore
        if ((this.button.shoot.isDown) && time > this.lastFired) {
            const laser = this.lasers.get(0,0, 'laser1')
            if(laser){
                laser.fire(this.player.x, this.player.y)
                this.lastFired = time + 800

                this.sound.play('laserSound')
            }
        }
        
    }

    spawnEnemy() {
        const config = {
            speed : this.enemySpeed,
            rotation : 0
        }

       
        // @ts-ignore
        const enemy = this.enemies.get(0,0, 'enemy2', config).setScale(0.1)

        const enemyWidth = enemy.displayWidth

        const positionX = Phaser.Math.Between(enemyWidth, this.scale.width - enemyWidth)

        if (enemy) {
            enemy.spawn(positionX)
        }
    }

    createPlayer() {
        const player = this.physics.add.sprite(200, 450, 'player')

        player.setCollideWorldBounds(true)

        this.anims.create({
            key: 'turn',
            frames:[{key:'player', frame:0}],
        })

        this.anims.create({
            key:'left',
            frames: this.anims.generateFrameNumbers(
                'player', {start:1, end:2}),
            frameRate:10
        })

        this.anims.create({
            key:'right',
            frames: this.anims.generateFrameNumbers(
                'player', {start:1, end:2}),
                frameRate:10
        })
        return player   
    }

    hitEnemy (laser, enemy){
        laser.erase()
        enemy.die()

        this.sound.play('destroySound')

        this.scoreLabel.add(2)
            if(this.scoreLabel.getScore() % 10 == 0) {
                this.enemySpeed += 45
            }
            if(this.scoreLabel.getScore() == 150){
                this.scene.start('win-scene',{score: this.scoreLabel.getScore()})
                this.sound.stopAll()
                this.sound.play('winSound')
            }
    }

    createScoreLabel(x,y,Score){
        const style = {fontSize: '32px', fill: '#FFFFFF'}
        const label = new ScoreLabel(this, x, y, Score, style).setDepth(1)

        this.add.existing(label)

        return label
    }

    createLifeLabel (x, y, life)
    {
        const style = { fontSize : `32px`, fill: '#FFFFFF'}
        const label = new LifeLabel(this, x, y, life, style).setDepth(1)

        this.add.existing(label)

        return label
    }

    decreaseLife(player, enemy)
    {
        enemy.die()
        this.lifeLabel.substract(1)

        if (this.lifeLabel.getLife() == 2) {
            player.setTint(0xff0000)

        } else if (this.lifeLabel.getLife() == 1){
            player.setTint(0xff0000).setAlpha(0.2)

        } else if (this.lifeLabel.getLife() == 0) {
            this.scene.start('game-over-scene',{score: this.scoreLabel.getScore()})
            this.sound.stopAll()
            this.sound.play('gameOverSound')
        }
    }

    spawnPowerup() {
        const config = {
            speed : 60,
            rotation : 0,
            scale : 0.3
        }

        // @ts-ignore
        const powerup = this.powerup.get(0,0, 'powerup', config).setScale(0.25)

        const powerupWidth = powerup.displayWidth

        const positionX = Phaser.Math.Between(powerupWidth, this.scale.width - powerupWidth)

        if (powerup) {
            powerup.spawn(positionX)
        }
    }

    increaseLife(player, powerup) {
        powerup.die()
        this.lifeLabel.add(1)

        this.sound.play('powerupSound')

        if (this.lifeLabel.getLife() >= 3) {
            player.clearTint().setAlpha(2)

        }
        else if (this.lifeLabel.getLife() == 2) {
            player.setTint(0xff0000)

        }
    
    }
}
